<template>
  <div
    :id="`${tag.tagGuid}-tag-item`"
    class="tag"
    :style="{
      color: tag.textColor,
      backgroundColor: tag.backgroundColor,
    }"
  >
    <b-tooltip
      :target="tag.tagName"
      :title="tag.tagName"
      placement="bottom"
    />
    <span :id="tag.tagName">
      {{ tag.tagName }}
    </span>
    <b-dropdown
      no-caret
      size="sm"
      variant="outline"
      boundary
      bottom
    >
      <template #button-content>
        <font-awesome-icon
          :style="{color: tag.textColor}"
          :icon="['fas', 'ellipsis-v']"
        />
      </template>
      <b-dropdown-item
        class="tag__menu--item"
        @click="editTag"
      >
        Edit
        <font-awesome-icon :icon="['fas', 'edit']" />
      </b-dropdown-item>
      <b-dropdown-item
        class="tag__menu--item relation"
        @click="onDeleteRelation"
      >
        Delete
        <font-awesome-icon :icon="['fas', 'close']" />
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script>

import {createNamespacedHelpers} from 'vuex';

const {
  mapActions: tagsMapActions,
} = createNamespacedHelpers('tags');
export default {
  name: 'TagComponent',
  props: ['tag'],
  data() {
    return {
      tableGuid: null,
      isLoading: false,
    };
  },
  methods: {
    ...tagsMapActions([
      'setAddEditTagModalState',
      'deleteTagRelation',
    ]),
    async onDeleteRelation() {
      const confirm = await this.$confirm(
        'Delete domain',
        'Are you sure you want to remove the domain from the entity?',
      );
      if (confirm) {
        this.isLoading = true;
        await this.deleteTagRelation({
          tableId: this.tableGuid,
          tagId: this.tag.tagGuid,
        });
        this.isLoading = false;
      }
    },
    editTag() {
      this.setAddEditTagModalState({
        isOpen: true,
        data: this.tag,
        isEditMode: true,
      });
    },
  },
  beforeMount() {
    this.tableGuid = this.$route.params.tableUuid;
  },
};
</script>


<style scoped lang="scss">
.tag {
  display: flex;
  align-items: center;
  padding: 5px 0 5px 5px;
  border-radius: 6px;
  border: 1px solid;
  margin-bottom: 0;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
  }
}

.b-dropdown {
  .tag__menu--item .dropdown-item {
    transition: 0.4s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
  }
  
  .dropdown-toggle {
    padding: 0 5px;
  }

  .relation .dropdown-item {
    padding-right: 12px;
  }
}
</style>